import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This npm Solo Payment Plan (this `}<em parentName="p">{`Payment Plan`}</em>{`) supplements
the terms for npm Open Source offered by npm, Inc. (`}<em parentName="p">{`npm`}</em>{`) at
`}<a parentName="p" {...{
        "href": "/policies/open-source-terms"
      }}>{`https://docs.npmjs.com/policies/open-source-terms`}</a>{` (`}<em parentName="p">{`npm Open Source
Terms`}</em>{`), as well as the terms for npm Paid Services (`}<em parentName="p">{`npm Paid Services`}</em>{`)
at `}<a parentName="p" {...{
        "href": "/policies/private-terms"
      }}>{`https://docs.npmjs.com/policies/private-terms`}</a>{`(`}<em parentName="p">{`npm Paid
Services Terms`}</em>{`). This Payment Plan governs payment for use of
npm Solo by a single user account.`}</p>
    <p>{`This Payment Plan was last updated on
August 6, 2018.
You can review prior versions at
`}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/blob/main/content/policies/solo-plan.mdx"
      }}>{`https://github.com/npm/documentation/blob/main/content/policies/solo-plan.mdx`}</a>{`.`}</p>
    <p>{`You will pay $7.00 via your Payment Card when you enable npm Solo
for your Account by selecting this Payment Plan, and thereafter
on the same day every month while this Payment Plan remains
selected for your Account.`}</p>
    <p>{`Note that the npm Paid Services Terms require everyone using npm Paid
Services to have an Account of their own, added under a Payment Plan.
You may not allow anyone else to use npm Paid Services under this
Payment Plan.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      